import { createSelector } from 'reselect';

import { getState as getParent } from 'modules/predefinedMessages/selectors';

export const getState = createSelector(getParent, state => state.ui.dashboard);

/** @type {function():Object<string, any>} */
export const getFilters = createSelector(getState, state => state.filters);
